var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"app",staticClass:"app page-admin",attrs:{"id":"app"}},[_c('MainAdminHeader'),_c('BlockAdminSidebar'),_c('main',{staticClass:"site-main site-main--dashboard"},[_c('router-view')],1),_c('PartBackToTop')],1)}
var staticRenderFns = []

export { render, staticRenderFns }